import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Components
import YourReviews from './YourReviews';
// Locale
import messages from '../../locale/jsonMessages';

import cs from '../../components/commonStyle.css';
import s from './Reviews.css';

const Reviews = (props) => {

  const [current, setCurrent] = useState('responded');
  const [searchKey, setSearchKey] = useState('');
  const [isDataLoading, setIsDataLoading] = useState(false);

  const handleClick = async (type, current) => {
    setIsDataLoading(true)
    const { reviewsData: { refetch } } = props;
    let variables = { ownerType: type, offset: 0, current };
    setCurrent(current);
    await refetch(variables);
    setIsDataLoading(false)
  }

  const handleSearchChange = async (searchKey) => {
    const { reviewsData: { refetch }, type } = props;
    let variables = {
      searchKey,
      current,
      type: 'others'
    };
    setSearchKey(searchKey);
    refetch(variables);
  }

  const { reviewsData, reviewsData: { userReviews, loading }, loadMore, type, isLoading } = props;
  const { formatMessage } = useIntl();
  return (
    <div className={cx('reviews', s.reviewPanel, 'whiteBgColor', 'youcarsBg')}>
      <ul className={cx(cs.listContainer, cs.dFlex, s.mobileFlexContainer)}>
        <li className={current === 'responded' ? s.active : ''}>
          <a className={cx(cs.listTabItem, s.tabItem, 'tabLinkRTL', 'textWhite')} onClick={() => handleClick('others', 'responded')}>
            <FormattedMessage {...messages.responded} />
          </a>
        </li>
        <li className={current === 'notResponded' ? s.active : ''}>
          <a className={cx(cs.listTabItem, s.tabItem, 'tabLinkRTL', 'textWhite')} onClick={() => userReviews?.results && handleClick('others', 'notResponded')}>
            <FormattedMessage {...messages.notResponded} />
          </a>
        </li>
      </ul>

      {!isDataLoading && reviewsData && userReviews && userReviews.totalCount > 0 &&
        <div className={cx(cs.spaceTop5, s.searchBox)}>
          <input placeholder={formatMessage(messages.searchReviews)} type="" className={cx('commonSearchIconInput', s.searchReviewInput)} onChange={(e) => handleSearchChange(e.target && e.target.value)} maxLength={255} />
        </div>
      }
      <YourReviews isDataLoading={isDataLoading} data={isDataLoading ? { userReviews: null, loading: true } : reviewsData} loadMore={loadMore} current={current} searchKey={searchKey} isLoading={isLoading} />
    </div>
  );
}

Reviews.propTypes = {
  reviewsData: PropTypes.shape({
    loading: PropTypes.bool,
    formatMessage: PropTypes.any,
    userReviews: PropTypes.array,
    refetch: PropTypes.any
  }),
  loadMore: PropTypes.any.isRequired
};

Reviews.defaultProp = {
  reviewsData: {
    loading: true
  },
};

export default withStyles(s)(Reviews);
